import React from "react";
import { webAddresses, telephoneNumbers } from "../../utils/contactDetails";
import brandConfig from "../../utils/brandConfig";

const Footer = props => {
  const { brand, freePackage } = props;

  const FooterNote = props => {
    const { text, link } = props;
    return (
      <div>
        - {text && text}
        <a href={link && link.href} target="_blank" rel="noopener noreferrer">
          {link && link.name}
        </a>{" "}
        -
      </div>
    );
  };

  const getPrintHref = brand => {
    const filter = brandConfig.filter(item => item.brand === brand);
    return filter[0]
      ? filter[0].printableOrderForm
      : brandConfig[0].printableOrderForm;
  };

  return (
    <footer id="footer">
      {brand === "TB" ? (
        <div>
          <div>
            <FooterNote
              text="For KS3-GCSE please visit "
              link={webAddresses.examproDiscount}
            />
          </div>
        </div>
      ) : (
        <FooterNote
          text="For KS1 and KS2 go to "
          link={webAddresses.testbaseDiscount}
        />
      )}
      {freePackage ? "" : 
        <a className="print-btn" href={getPrintHref(brand)} target="_blank" rel="noreferrer" role="button">
        <i className="fa fa-print"></i> Printable order form
        </a>
      }
      <ul>
        <li>&copy; Doublestruck Ltd. {new Date().getFullYear()}</li>
        <li>
          <a
            href={webAddresses.termsAndConditions.href}
            target="_blank"
            rel="noopener noreferrer"
          >
            Terms of Use
          </a>
        </li>
        <li>
          <a
            href={webAddresses.privacyStatement.href}
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy Notice
          </a>
        </li>
        <li>
          <a
            href={webAddresses.cookiePolicy.href}
            target="_blank"
            rel="noopener noreferrer"
          >
            Cookie Policy
          </a>
        </li>
      </ul>
    </footer>
  );
};

export default Footer;
